import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Navbar from "./components/Navbar";
// import Footer from "./components/Footer";
import HomeContent from "./components/HomeContent";
import ProductDetailsPage from "./components/ProductDetailsPage";
import ProductDetailsById from "./components/ProductDetailsById";// New import
import ProductsPage from "./components/ProductsPage";
import AboutUs from "./components/AboutUs";
import CartPage from "./components/CartPage";
import OrdersPage from "./components/OrdersPage";
import OrderDetail from "./components/OrderDetail";
import RecommendationsPage from "./components/RecommendationsPage";
import { getCartItems } from "./api/Product.services";
import "./App.css";
import Layout from "./components/Layout/Layout";

function App() {
  const [cartItems, setCartItems] = useState(0);

  // Fetch cart items on mount
  useEffect(() => {
    async function fetchCartItems() {
      try {
        const response = await getCartItems();
        setCartItems(response[0]?.items?.length || 0);
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    }
    fetchCartItems();
  }, []);


  return (
    <div className="App">
      <Router>
        {/* <Navbar cartItems={cartItems} /> */}
        {/* <div className="content mb-5 mt-5"> */}
          <Routes>
            <Route path="/" element={<Layout cartItems={cartItems} setCartItemsCount={setCartItems} />}>
              <Route path="/" index element={<HomeContent />} />
              <Route path="/" element={<HomeContent />} />
              <Route path="/products/:category" element={<ProductsPage setCartItemsCount={setCartItems} />} />
              <Route path="/products/:category/:subCategory" element={<ProductsPage setCartItemsCount={setCartItems} />} />
              {/* <Route path="/product-details/:id" element={<ProductDetailsPage />} /> */}
              <Route path="/product-details/:productId" element={<ProductDetailsPage setCartItemsCount={setCartItems} />} />
              <Route path="/product-details-by-id" element={<ProductDetailsById />} />
              <Route path="/orders" element={<OrdersPage />} />
              <Route path="/orders/:orderId" element={<OrderDetail />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/cart" element={<CartPage setCartItemsCount={setCartItems} />} />
              <Route path="/recommendations" element={<RecommendationsPage />} />
            </Route>
          </Routes>
        {/* </div> */}
        {/* <Footer /> */}
      </Router>
    </div>
  );
}

export default App;
